import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { CrudService } from '../../../core';
import { Estado } from '../estado';

@Injectable({
    providedIn: 'root'
})
export class EstadoCrudHttpService {
    resource = 'estado';

    constructor(private crudService: CrudService) { }

    /** Pesquisa todas os estados cadastrados */
    search(incluirExterior = true): Observable<Estado[]> {
        const params = incluirExterior ? new HttpParams().set('includes', 'exterior') : undefined;
        return this.crudService.search<Estado>(this.resource, {params});
    }
}
